import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-view-commercial-detail',
  templateUrl: './modal-view-commercial-detail.component.html',
  styleUrls: ['./modal-view-commercial-detail.component.scss']
})
export class ModalViewCommercialDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
